export enum CALPADSFileTypeEnum {
  SPED = "SPED",
  SSRV = "SSRV",
  PSTS = "PSTS",
  SWDS = "SWDS",
  PLAN = "PLAN",
  MEET = "MEET",
  SERV = "SERV"
}
